export enum EDeviceType {
  DESKTOP = 0,
  TABLET,
  MOBILE,
}